import { render, staticRenderFns } from "./storeClose.vue?vue&type=template&id=3022795a"
import script from "./storeClose.vue?vue&type=script&lang=ts"
export * from "./storeClose.vue?vue&type=script&lang=ts"
import style0 from "./storeClose.vue?vue&type=style&index=0&id=3022795a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports